import { InputAlert } from '@creditornot/cb-input';
import { SegmentedControl } from '@creditornot/cb-segmented-control';
import React from 'react';
import { Field, useFormState } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { BaseField } from './types';
import { useOfferOverridesContext } from '../../../context/OfferOverridesContext';
import { FormRowRenderer } from '../FormRowRenderer';
import { PreviewRowContainer } from '../OfferDetailsFormFields.styles';
import { FormValues } from '../types';

type Props = BaseField & { isSingleVenue: boolean };

export const InventoryType = ({ sidePanelMode, isSingleVenue }: Props) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const intl = useIntl();
  const { values } = useFormState<FormValues>();
  const { maybeOverriddenOffer } = useOfferOverridesContext();
  const fieldNameToUse = isSingleVenue ? 'inventoryMode' : 'inventoryModeOverride';

  const previewComponent = (
    <>
      {maybeOverriddenOffer?.inventory_mode === 'limited_quantity' && (
        <PreviewRowContainer>
          <FormattedMessage id="menu-item.enabled-false" />
        </PreviewRowContainer>
      )}
      {maybeOverriddenOffer?.inventory_mode !== 'limited_quantity' && (
        <PreviewRowContainer>
          {!maybeOverriddenOffer?.inventory_mode || maybeOverriddenOffer?.inventory_mode === 'forced_out_of_stock' ? (
            <FormattedMessage id="inventory-management.binary" />
          ) : (
            <FormattedMessage id="inventory-management.track-count" />
          )}
        </PreviewRowContainer>
      )}
    </>
  );

  const editComponent = (
    <>
      {values[fieldNameToUse] === 'limited_quantity' && (
        <InputAlert variant="info">
          <FormattedMessage id="inventory-management.turn-off-info" />
        </InputAlert>
      )}
      {values[fieldNameToUse] !== 'limited_quantity' && (
        <Field name={fieldNameToUse}>
          {field => (
            <SegmentedControl
              {...field.input}
              options={[
                { value: 'binary', label: intl.formatMessage({ id: 'inventory-management.binary' }) },
                {
                  value: 'inventory',
                  label: intl.formatMessage({ id: 'inventory-management.track-count' }),
                },
              ]}
            />
          )}
        </Field>
      )}
    </>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'inventory-management.type' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      sidePanelMode={sidePanelMode}
      offer={maybeOverriddenOffer}
      isOnlyForVenueLevel
    />
  );
};
